export const MONTH_CHANGE_SEASON = 7; // Le changement de saison se fait au mois d'août
export const LAST_DAY_BEFORE_CHANGE_SEASON = 31; // Il y a 31 jour en juillet
